import axios from "axios";
import store from "../store";

const APP_AUTH_TK = process.env.VUE_APP_AUTH_TK;
const APP_AUTH_ME = process.env.VUE_APP_AUTH_ME;

const app = {
  validate() {
    const token = JSON.parse(localStorage.getItem(APP_AUTH_TK));
    const user = JSON.parse(localStorage.getItem(APP_AUTH_ME));
    if (token) {
      axios.defaults.headers["Authorization"] = token.token;
      if (user) {
        if (user.username) {
          store.commit("user", user);
        }
      }
      // app.refresh();
      app.refreshUser();
    }
  },
  refresh(interval) {
    // if (interval) {
    //     if (window.tokenRefreshInterval) clearInterval(window.tokenRefreshInterval);
    //     window.tokenRefreshInterval = setInterval(app.refresh, interval);
    // }

    const token = JSON.parse(localStorage.getItem(APP_AUTH_TK));
    // const user = JSON.parse(localStorage.getItem(APP_AUTH_ME));
    if (token && token.refresh_token) {
      app.tokenRefreshed = (app.tokenRefreshed || 0) + 1;

      axios
        .post(`/auth/refresh`, { refresh_token: token.refresh_token })
        .then((resp) => {
          const { data } = resp;
          if (data.token) {
            localStorage.setItem(APP_AUTH_TK, JSON.stringify(data));
            axios.defaults.headers["Authorization"] = data.token;
          }
        })
        .catch((err) => {
          const redirectPath = localStorage.getItem("redirectPath");
          clearInterval(window.tokenRefreshInterval);
          window.localStorage.clear();
          if (redirectPath) localStorage.setItem("redirectPath", redirectPath);
          window.location.reload();
        });
    }
  },
  refreshUser() {
    axios
      .get(`/users/me`)
      .then((resp) => {
        const { data } = resp;
        if (data) {
          localStorage.setItem(APP_AUTH_ME, JSON.stringify(data));
          store.commit("user", data);
        }
      })
      .catch((err) => {
        console.log("refresh current user:", err);
      });
  },
};

export default app;
